import React from "react";
import { ArrowRight, MapPin, House, TreePine, TrainFront } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const towns = [{
  name: "Warwick",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560620/img/warwick_main_street.png",
  stats: ["Historic Charm", "Farm-to-Table", "1hr to NYC"],
  description: "A vibrant community known for its wineries, apple orchards, and historic downtown district.",
  colSpan: "lg:col-span-7"
}, {
  name: "Goshen",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560620/img/goshen_historic_track.png",
  stats: ["County Seat", "Top Schools", "Legoland NY"],
  description: "The heart of Orange County, blending rich history with modern family-friendly amenities.",
  colSpan: "lg:col-span-5"
}, {
  name: "Monroe",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560620/img/monroe_lakeside.png",
  stats: ["Lakeside Living", "Harriman Park", "Shopping Hub"],
  description: "Scenic beauty meets convenience, offering easy access to state parks and premium shopping.",
  colSpan: "lg:col-span-5"
}, {
  name: "Cornwall",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560620/img/cornwall_river_view.png",
  stats: ["River Views", "Art Scene", "Quiet Retreat"],
  description: "A peaceful riverside haven with a thriving arts community and breathtaking Hudson Valley vistas.",
  colSpan: "lg:col-span-7",
  nameClassName: "absolute inset-0 flex flex-col justify-between p-6 md:p-8 !bg-[url(https://findahomewithchris.com/wp-content/uploads/2026/02/Screenshot-2026-02-28-163102.png)]"
}];
export default function OrangeCountyLife() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="orange-county-life" className="dark text-foreground py-20 px-4 overflow-hidden !bg-[hsl(0,0%,0%)] md:py-32">
      <div className="container mx-auto max-w-7xl">
        {}
        <div ref={ref} className={`mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="max-w-2xl">
            <h2 className="text-primary font-medium tracking-wider uppercase mb-3 text-sm">
              Neighborhood Spotlight
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-white leading-tight">&nbsp;Communities of&nbsp;<span className="italic text-white/90" data-ast-id="f:/src/pages/Home/sections/OrangeCountyLife.tsx|sig:q5cq5q" data-ast-start="2638" data-ast-end="2697">Orange County</span></h3>
          </div>
          <div className="max-w-md">
            <p className="text-white/70 text-lg font-light leading-relaxed">
              Discover the unique character of the Hudson Valley. From riverside retreats to bustling historic hubs, find the perfect backdrop for your lifestyle.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-6">
          {towns.map((town, i) => <Link key={town.name} to="/CommunitiesPage" className={`group block relative h-[400px] md:h-[500px] w-full overflow-hidden rounded-xl ${town.colSpan}`} data-index={i}>
              <Card className="h-full w-full border-none bg-transparent p-0 overflow-hidden rounded-xl">
                {}
                <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-out group-hover:scale-105" style={{
              backgroundImage: `url(${town.image})`
            }} />
                
                {}
                <div className="absolute inset-0 bg-black/20 transition-colors duration-500 group-hover:bg-black/40" />

                {}
                <CardContent className={`${town.nameClassName || ""} absolute inset-0 flex flex-col justify-between p-6 md:p-8`}>
                  {}
                  <div className="flex justify-end">
                    <Badge variant="secondary" className="opacity-0 translate-y-[-10px] transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0 bg-white/90 text-[#1A2F23] hover:bg-white backdrop-blur-sm shadow-lg">
                      View Neighborhood Guide <ArrowRight className="ml-1 h-3 w-3" />
                    </Badge>
                  </div>

                  {}
                  <div className="mt-auto transform transition-transform duration-500 group-hover:translate-y-[-8px]">
                    <h4 className="text-3xl md:text-4xl font-serif text-white mb-3 tracking-tight">
                      {town.name}
                    </h4>
                    
                    <p className="text-white/80 text-sm md:text-base max-w-md mb-6 line-clamp-2 opacity-0 h-0 group-hover:opacity-100 group-hover:h-auto transition-all duration-500 delay-100">
                      {town.description}
                    </p>

                    {}
                    <div className="flex flex-wrap gap-3 items-center">
                      {town.stats.map((stat, idx) => <span key={idx} className="inline-flex items-center text-[10px] md:text-xs font-sans font-bold uppercase tracking-widest text-white/90 bg-white/10 px-3 py-1 rounded-full backdrop-blur-md border border-white/10">
                          {idx === 0 && <MapPin className="mr-1.5 h-3 w-3 opacity-70" />}
                          {idx === 1 && <House className="mr-1.5 h-3 w-3 opacity-70" />}
                          {idx === 2 && <TreePine className="mr-1.5 h-3 w-3 opacity-70" />}
                          {stat}
                        </span>)}
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}